import React, { Fragment, memo } from 'react';
import previewMobile from '@Theme/icons/preview-mobile.png';
import androidTrangleIcon from '@Theme/icons/android-triangle.png';
import androidIcon from '@Theme/icons/android-os-min.png';
import { BigCountDownPush } from './bigCountDown';
import { CountDownProgressPush } from './countDownProgress';
import { CountDownPush } from './countDown';

function PushPreview({ variation, productTitle }) {
  const shouldShowButtons =
    (Array.isArray(variation.androidButtons) &&
      variation.androidButtons?.length > 0) ||
    variation.androidButton1Label ||
    variation.androidButton2Label;

  const renderCountDown = () => {
    const { pushType, timerTemplate } = variation;
    if (pushType === 'TIMER') {
      switch (timerTemplate?.type) {
        case 'PLAIN':
          return <CountDownPush variation={variation} />;
        case 'PROGRESS_BAR':
          return <CountDownProgressPush variation={variation} />;
        case 'BIG':
          return <BigCountDownPush variation={variation} />;
        default:
          return null;
      }
    }
    return null;
  };
  return (
    <section className="message-container__preview overflow-hidden">
      <div className="pos-relative w-100 h-100 overflow-hidden">
        <div className="message-container__content">
          <div className="push-notification push-notification--android">
            <img src={previewMobile} style={{ maxWidth: '100%' }} />
            <div
              className="push-notification__block"
              style={{
                ...{
                  top: 70,
                  width: '85%',
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  left: '20px',
                  padding: 8,
                },
              }}
            >
              {renderCountDown()}

              <div
                className="push-notification__message"
                style={{ padding: 0, width: 220 }}
              >
                <div style={{ padding: 16 }}>
                  <div className="push-notification__upper-container">
                    <div style={{ width: '100%' }}>
                      {variation?.pushType !== 'TIMER' && (
                        <div className="push-notification__system-info">
                          <img
                            src={androidTrangleIcon}
                            className="push-notification__system-icon"
                          />
                          <span className="push-notification__system-title">
                            {productTitle}
                          </span>
                          <span>&nbsp;&nbsp;</span>
                          <span className="push-notification__system-time">
                            <i className="fl-dark fl-chevron-bottom line-height-0"></i>
                          </span>
                        </div>
                      )}
                      <div className="push-notification__title">
                        {variation?.pushType !== 'TIMER'
                          ? variation.subject
                          : ''}
                      </div>

                      <div
                        className={
                          variation && variation.pushType === 'TEXT'
                            ? 'push-notification__description'
                            : 'push-notification__description text-ellipsis'
                        }
                      >
                        {variation?.pushType !== 'TIMER'
                          ? variation.message
                          : ''}
                      </div>
                    </div>
                    {variation?.pushType !== 'TIMER' && (
                      <div className="push-notification__section-right">
                        <img
                          className="push-notification__icon"
                          style={{ maxWidth: '100%' }}
                          src={androidIcon}
                        />
                      </div>
                    )}
                  </div>
                  {variation &&
                    variation.image &&
                    variation?.pushType !== 'TIMER' && (
                      <div
                        className="push-notification__banner"
                        style={{
                          backgroundImage: 'url("' + variation.image + '")',
                          height: 149,
                          backgroundSize: 'cover',
                        }}
                      ></div>
                    )}
                </div>
                {shouldShowButtons && (
                  <div
                    className="push-notification__buttons-container"
                    style={{
                      marginTop: 10,
                      display: 'flex',
                      maxHeight: 80,
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingInline: 0,
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        gap: 8,
                        flex: 1,
                        alignItems: 'center',
                        paddingInline: 8,
                      }}
                    >
                      {variation.androidButtons &&
                      Array.isArray(variation.androidButtons) ? (
                        variation.androidButtons.map((btn, index) => (
                          <button
                            key={index}
                            style={{ width: '100%' }}
                            onClick={btn.onClick}
                          >
                            {btn.label}
                          </button>
                        ))
                      ) : (
                        <Fragment>
                          {variation.androidButton1Label && (
                            <button
                              style={{ width: '100%' }}
                              onClick={variation.androidButton1OnClickAction}
                            >
                              {variation.androidButton1Label}
                            </button>
                          )}
                          {variation.androidButton2Label && (
                            <button
                              style={{ width: '100%' }}
                              onClick={variation.androidButton2OnClickAction}
                            >
                              {variation.androidButton2Label}
                            </button>
                          )}
                        </Fragment>
                      )}
                      {variation.androidDismissButtonLabel && (
                        <button style={{ width: '100%' }}>
                          {variation.androidDismissButtonLabel}
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Memoized = memo(PushPreview);

export { Memoized as PushPreview };
